import {
	AuthenticatedTemplate,
	UnauthenticatedTemplate
} from '@azure/msal-react';
import { PropsWithChildren } from 'react';
import { AuthRequired } from './authrequired';

export const ForceAuthentication = (props: PropsWithChildren) => {
	return (
		<>
			<AuthenticatedTemplate>{props.children}</AuthenticatedTemplate>
			<UnauthenticatedTemplate>
				<AuthRequired />
			</UnauthenticatedTemplate>
		</>
	);
};
